import { Link } from "react-router-dom";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { Reveal } from "./motion-primitives";
import { useSeo } from "./useSeo";

// Minimal contact destination. No invented email/phone/social — enquiries begin at Plan My Trip.
export const ContactPage = () => {
  useSeo({
    title: "Contact — Holideviser",
    description: "Start a trip enquiry with Holideviser. Every journey begins with Plan My Trip.",
  });

  return (
    <div className="min-h-screen bg-ink text-cream" data-testid="contact-page">
      <Navigation />
      <main className="mx-auto max-w-[900px] px-6 pb-24 pt-40 sm:px-10 lg:pt-52">
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-teal" />
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-teal">Contact</span>
          </div>
        </Reveal>
        <Reveal delay={0.06}>
          <h1 className="max-w-3xl font-serif text-5xl font-light leading-[1.03] tracking-tight text-cream sm:text-6xl">
            Let&apos;s shape your <span className="italic text-teal">trip.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-xl font-sans text-base leading-relaxed text-sand sm:text-lg">
            Have a holiday in mind? Share a short trip brief and we'll follow up about the details. You can
            enquire about destinations beyond our published guides.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <Link
            to="/plan-my-trip"
            data-testid="contact-plan-cta"
            className="mt-10 inline-block rounded-none bg-teal px-8 py-4 font-sans text-sm uppercase tracking-[0.18em] text-ink transition-colors hover:bg-cream"
          >
            Plan my trip
          </Link>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
};
